'use client';

import { FC } from 'react';
import HeroSection from './components/HeroSection';
import PlaybooksContainer from './components/PlaybooksContainer';


const PlaybooksPage: FC = () => {
  return (
    <div className='bg-white text-gray-900'>
      <HeroSection />
      <PlaybooksContainer />
    </div>
  );
};

export default PlaybooksPage;
